// @flow
import { all, put, select, takeEvery } from 'redux-saga/effects';
import { checkOrderConsistency } from '@tripica/check-order-consistency';

import { setLoading } from '../../LoadingStatus/actions';
import type { SignUpCheckOrderConsistencyActionType } from './actions';
import { setSignUpCheckOrderConsistencyStatus } from './actions';

import { customerSelector } from '../../Customer/selectors';
import { newOfferOptionsMappedByCreditableServiceSelector } from '../../NewOffer/selectors';
import { deliveryAddressSelector } from '../DeliveryAddress/reducer';
import { deliveryContactSelector } from '../DeliveryContact/reducer';
import { chosenPhoneNumberSelector } from '../PhoneNumber/reducer';
import { identificationDocumentSelector } from '../Identifications/reducer';
import { emailSelector } from '../Login/reducer';

export function* signUpCheckOrderConsistencySaga(action: SignUpCheckOrderConsistencyActionType): Generator<*, *, *> {
  if (action.type !== 'SIGNUP_CHECK_ORDER_CONSISTENCY') return;

  yield put(setLoading('signUpCheckOrderConsistencySaga', true));

  const customer = yield select(customerSelector);
  const deliveryAddress = yield select(deliveryAddressSelector);
  const deliveryContact = yield select(deliveryContactSelector);
  const options = yield select(newOfferOptionsMappedByCreditableServiceSelector);
  const phoneNumber = yield select(chosenPhoneNumberSelector);
  const document = yield select(identificationDocumentSelector);
  const notificationContact = yield select(emailSelector);

  const orderDetails = {
    deliveryAddress,
    deliveryContact,
    identificationType: document?.identificationType,
    notificationContact,
    options,
    phoneNumber,
    customer,
  };

  const isOrderOk = checkOrderConsistency(orderDetails, [
    'phoneNumber',
    'deliveryAddress',
    'deliveryContact',
    'options',
    'customer',
    'notificationContact',
    'identificationType',
  ]);

  yield put(setSignUpCheckOrderConsistencyStatus(isOrderOk === 'ORDER_OK'));

  yield put(setLoading('signUpCheckOrderConsistencySaga', false));
}

export default function*(): Generator<*, *, *> {
  yield all([takeEvery('SIGNUP_CHECK_ORDER_CONSISTENCY', signUpCheckOrderConsistencySaga)]);
}
